import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc: string;
  resetLabel?: string;
  onReset?: () => void;
  homeLabel?: string;
}

export default function EmptyState({
  icon = "ri-file-search-line",
  title,
  desc,
  resetLabel,
  onReset,
  homeLabel,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{desc}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {resetLabel && onReset && (
          <button
            type="button"
            onClick={onReset}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {resetLabel}
          </button>
        )}
        <Link
          to="/"
          className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-400"
        >
          {homeLabel ?? "返回首页"}
        </Link>
      </div>
    </div>
  );
}